<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>An Introduction to the Scriptures of Israel: History and Theology</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="abb"><a id="page_ix"></a><a href="#/xhtml/contents#abb1">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="tab">
<tbody><tr>
<td class="abb"><i>COS</i></td>
<td class="abb1"><i>The Context of Scripture.</i> Edited by William W. Hallo and K. Lawson Younger Jr. 4 vols. Leiden: Brill, 1997–2017</td>
</tr>
<tr>
<td class="abb">NJPS</td>
<td class="abb1">New Jewish Publication Society Version (<i>Tanakh</i>)</td>
</tr>
<tr>
<td class="abb">NRSV</td>
<td class="abb1">New Revised Standard Version</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?1d3874e0